import React from "react";
import {Select} from "antd";
import {shiftRequestStatuses} from "constants/constants";

export const ShiftRequestStatusFilter = ({
    value,
    onChange,
    allowClear = true,
    placeholder = "Durum Seç",
    style = {minWidth: "150px"},
    showLabel = true,
    marginBottom = "12px"
}) => {
    return (
        <div style={{marginBottom}}>
            {showLabel && <label style={{display: "block", marginBottom: 8}}>Durum</label>}
            <Select
                placeholder={placeholder}
                style={style}
                allowClear={allowClear}
                value={value}
                onChange={onChange}
                options={shiftRequestStatuses}
            />
        </div>
    );
};
